export default __webpack_public_path__ + "static/media/Porque-Portugal-EN.d9096265.jpg";